if (!customElements.get('mobile-dock')) {
  customElements.define(
    'mobile-dock',
    class MobileDock extends HTMLElement {
      constructor() {
        super();

        if (Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }

      get section() {
        return this._section = this._section || this.closest('.mobile-dock-section');
      }

      init() {
        if (this.initialized) return;
        this.initialized = true;
        this.setAttribute('loaded', '');

        // Always-on dock: no scroll/header gating. Just expose the rendered
        // height so footer/sticky children can offset themselves.
        setTimeout(this.setHeight.bind(this));
        document.addEventListener('matchSmall', this.setHeight.bind(this));
        window.addEventListener('resize', theme.utils.throttle(this.setHeight.bind(this)));
      }

      setHeight() {
        const totalHeight = this.offsetHeight + this.getBottomInset();
        document.documentElement.style.setProperty('--mobile-dock-height', `${totalHeight}px`);
      }

      getBottomInset() {
        // Approximate the safe-area inset (env() can't be read directly from JS).
        const probe = document.createElement('div');
        probe.style.cssText = 'position:fixed;bottom:env(safe-area-inset-bottom,0px);visibility:hidden;';
        document.body.appendChild(probe);
        const inset = parseInt(getComputedStyle(probe).bottom) || 0;
        probe.remove();
        return inset;
      }
    }, { extends: 'nav' }
  );
}
